import { useNavigate } from "react-router-dom"

export const EdgeNetHome = () => {
    const navigate = useNavigate();
    return (
        <>


            <div className="flex items-center justify-center min-h-screen z-999">
                <div className="absolute left-4 top-2 w-40">
                    <img src="https://digiit.biz/assets/digiit-logo-dark.png" />
                </div>

                <div className="w-full text-center">
                    <h2 className="max-w-screen mb-24 font-sans text-3xl font-bold leading-none tracking-tight text-[#090816] sm:text-4xl md:mx-auto">
                        "Build DIGIIT Edge Network"
                    </h2>
                    <div className="relative px-4 sm:px-0">
                        <div className="absolute inset-0 bg-[#F2861D]  h-1/2" />
                  <div className="relative grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 max-w-screen-xl mx-auto">
                            <div className="inline-block  mx-4 p-8 text-center bg-[#090816] cursor-pointer hover:border border[#F9D2AB]" onClick={() => { window.open('/management/auth/login', '_blank', 'noopener,noreferrer') }}>
                                <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 rounded-full bg-[#090816]">

                                    <svg width="200" height="200" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M20,100 L100,20 L180,100 L100,180 Z" fill="none" stroke="#DBDBDA" stroke-width="12" />
                                        <path d="M60,100 L100,60 L140,100 L100,140 Z" fill="none" stroke="#DBDBDA" stroke-width="8" />
                                        <line x1="20" y1="100" x2="180" y2="100" stroke="#DBDBDA" stroke-width="6" />
                                        <line x1="100" y1="20" x2="100" y2="180" stroke="#DBDBDA" stroke-width="6" />
                                        {/* <text x="100" y="190" text-anchor="middle" font-family="Arial, sans-serif" font-size="20" fill="#DBDBDA" font-weight="bold">
                                        Edge Application
                                    </text> */}
                                    </svg>
                                </div>
                                <p className="font-bold tracking-wide text-[#DBDBDA]">
                                    POP
                                </p>
                                <p className="text-xs font-light text-[#DBDBDA]">
                                    Platform management & Infrastructure Management
                                </p>
                            </div>
                            <div className="inline-block mx-4 p-8 text-center bg-[#090816] cursor-pointer hover:border border[#F9D2AB]" onClick={() => { window.open('/dbn/auth/login', '_blank', 'noopener,noreferrer') }}>
                                <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 rounded-full bg-[#090816]">
                                    <svg width="200" height="200" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" transform="scale(1.5)">
                                        <circle cx="100" cy="50" r="10" fill="#DBDBDA" />
                                        <circle cx="150" cy="100" r="10" fill="#DBDBDA" />
                                        <circle cx="100" cy="150" r="10" fill="#DBDBDA" />
                                        <circle cx="50" cy="100" r="10" fill="#DBDBDA" />

                                        <line x1="100" y1="50" x2="150" y2="100" stroke="#DBDBDA" stroke-width="6" />
                                        <line x1="150" y1="100" x2="100" y2="150" stroke="#DBDBDA" stroke-width="6" />
                                        <line x1="100" y1="150" x2="50" y2="100" stroke="#DBDBDA" stroke-width="6" />
                                        <line x1="50" y1="100" x2="100" y2="50" stroke="#DBDBDA" stroke-width="6" />

                                        <circle cx="100" cy="100" r="12" fill="#DBDBDA" />

                                        {/* <text x="100" y="190" text-anchor="middle" font-family="Arial, sans-serif" font-size="20" fill="#DBDBDA" font-weight="bold">
                                        Business Network
                                    </text> */}
                                    </svg>



                                </div>
                                <p className="font-bold tracking-wide text-[#DBDBDA]">
                                    DBN
                                </p>
                                <p className="text-xs font-light text-[#DBDBDA]">
                                    NP Management & Taxonomy Management
                                </p>
                            </div>

                            <div className="inline-block  mx-4 p-8 text-center bg-[#090816] cursor-pointer hover:border border[#F9D2AB]" onClick={() => { window.open('/gateway/auth/login', '_blank', 'noopener,noreferrer') }}>
                                <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 rounded-full bg-[#090816]">

                                    <svg width="200" height="200" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M40,160 L160,160 L160,40 L40,40 Z" fill="none" stroke="#DBDBDA" stroke-width="12" />
                                        <path d="M60,140 L140,140 L140,60 L60,60 Z" fill="none" stroke="#DBDBDA" stroke-width="8" />
                                        <path d="M100,100 L100,60 M100,140 L100,100 M60,100 L100,100 M140,100 L100,100" fill="none" stroke="#DBDBDA" stroke-width="6" />
                                        {/* <text x="100" y="190" text-anchor="middle" font-family="Arial, sans-serif" font-size="20" fill="#DBDBDA" font-weight="bold">
                                            Gateway
                                        </text> */}
                                    </svg>


                                </div>
                                <p className="font-bold tracking-wide text-[#DBDBDA]">
                                    GATEWAY
                                </p>
                                <p className="text-xs font-light text-[#DBDBDA]">
                                    Gateways and System Integration Management
                                </p>
                            </div>
                            <div className="inline-block  mx-4 p-8 text-center bg-[#090816] cursor-pointer hover:border border[#F9D2AB]" onClick={() => { window.open('/digiit-ai/auth/login', '_blank', 'noopener,noreferrer') }}>
                                <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 pb-10 scale-x scale-x-[-1] rounded-full bg-[#090816]">


                                    <svg
                                        width="200"
                                        height="200"
                                        viewBox="0 0 200 200"
                                        xmlns="http://www.w3.org/2000/svg"
                                        stroke-width="6"
                                        transform="scale(2)"
                                    >
                                        <path
                                            d="M118.32,114.328c-10.378,0-19.914,5.71-24.825,14.852c-3.47-2.623-7.699-4.046-12.049-4.055
                                            c-11.073,0-20.049,8.976-20.049,20.049c0.004,0.21,0.012,0.421,0.023,0.631c-0.501-0.047-1.004-0.072-1.507-0.075
                                            c-9.469,0-17.144,7.675-17.144,17.144c0,9.468,7.676,17.143,17.144,17.143h81.417c9.468,0,17.144-7.675,17.144-17.143
                                            c-0.004-7.588-4.996-14.271-12.271-16.428c0.194-1.3,0.297-2.613,0.308-3.928c0-15.569-12.621-28.191-28.191-28.191Z"
                                            fill="none"
                                            stroke="#DBDBDA"
                                        />
                                    </svg>





                                </div>
                                <p className="font-bold tracking-wide text-[#DBDBDA]">
                                    DIGIIT.AI
                                </p>
                                <p className="text-xs font-light text-[#DBDBDA]">
                                    Guest Application. Client Application and Client Subscriptions Management
                                </p>
                            </div>

                             <div className="inline-block  mx-4 p-8 text-center bg-[#090816] cursor-pointer hover:border border[#F9D2AB]" onClick={() => { window.open('/partner/auth/login', '_blank', 'noopener,noreferrer') }}>
                                <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 pb-10 scale-x scale-x-[-1] rounded-full bg-[#090816]">


                                    <svg
                                        width="200"
                                        height="200"
                                        viewBox="0 0 200 200"
                                        xmlns="http://www.w3.org/2000/svg"
                                        stroke-width="6"
                                        transform="scale(2)"
                                    >
                                        <path
                                            d="M118.32,114.328c-10.378,0-19.914,5.71-24.825,14.852c-3.47-2.623-7.699-4.046-12.049-4.055
                                            c-11.073,0-20.049,8.976-20.049,20.049c0.004,0.21,0.012,0.421,0.023,0.631c-0.501-0.047-1.004-0.072-1.507-0.075
                                            c-9.469,0-17.144,7.675-17.144,17.144c0,9.468,7.676,17.143,17.144,17.143h81.417c9.468,0,17.144-7.675,17.144-17.143
                                            c-0.004-7.588-4.996-14.271-12.271-16.428c0.194-1.3,0.297-2.613,0.308-3.928c0-15.569-12.621-28.191-28.191-28.191Z"
                                            fill="none"
                                            stroke="#DBDBDA"
                                        />
                                    </svg>





                                </div>
                                <p className="font-bold tracking-wide text-[#DBDBDA]">
                                    Partner Portal
                                </p>
                                <p className="text-xs font-light text-[#DBDBDA]">
                                   Application for ONE Partner Network
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}